<template>
  <Select
    :items="arrayStatusOrcamento"
    :selectedItem="filter.statusOrcamento"
    :label="filtro.name"
    :searchPlaceholder="$i18n('interface.novo_filtro.buscar_status')"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :filtro_default="filtro.default"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        statusOrcamento: {
          id: '',
          name: '',
        },
      },
      arrayStatusOrcamento: [
        { id: 'Todos os ativos', name: 'Todos os ativos' },
        { id: 'Orçamentos ativos', name: 'Orçamentos ativos' },
        { id: 'Pedidos ativos', name: 'Pedidos ativos' },
        { id: 'Arquivados', name: 'Arquivados' },
        { id: 'Orçamentos reprovados', name: 'Orçamentos reprovados' },
      ],
    };
  },
  methods: {
    atualizar(statusOrcamento) {
      this.filter.statusOrcamento = statusOrcamento;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.statusOrcamento.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.statusOrcamento.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.arrayStatusOrcamento, this.filter.statusOrcamento);
  },
}
</script>
